import { apiConfig } from "../config/apiConfig";

const { REACT_APP_STAGE } = process.env;

export const getTrackingDetails = (region: string) => {
   return apiConfig[REACT_APP_STAGE][region].getTrackingDetails;
};

export const getTrackingDetailsForSupplyChain = (region: string) => {
   return apiConfig[REACT_APP_STAGE][region].getTrackingDetailsForSupplyChain;
};